<div class="error-wrapper">
  <img src="../../assets/images/error.svg" alt="Error" />
  <h1>Ooops sorry, something went wrong!</h1>
  <p>
    We are currently working on a fix to have this up and running in no time,
    we're <br />
    sorry for any inconvenience and thank you for your patience
  </p>
</div>
